import "../../assets/css/overview.css";

function OverviewColumnSection(props) {
    const section = props.section;
    const rewards = section && section.rewards ? section.rewards : null;

    return (
        <div className="overview-swimlane-container">
            <div className="column-content">
                <div className="swimlane-top">
                    <div className="swimlane-title">
                        {section.title ? section.title : section.name ? section.name : "Featured Benefits"}
                    </div>
                </div>
                <div className="swimlane-subtitle">{section.subtitle ?
                    section.subtitle : section.desc ? section.desc : "Don’t miss out on these limited-time perks."}</div>
                <div className="swimlane-content column">
                    <div className={`overview-column-section ${props['two-col'] ? 'two-col' : ''}`}>
                        { rewards && rewards.map((reward, i) => 
                            <a className="column-reward" target="_blank" rel="noreferrer" key={i} href={reward.extra_data.reward_url} data-track="click"
                            data-id="nba:membership-hub:outbound:cta" data-content={reward.title} data-type="cta">
                                <img className="reward-img" src={reward.image} alt={`Badge: ${reward.title}`} />
                                <div className="reward-text">
                                    <div className="title">{reward.title}</div>
                                    <p className="desc">{reward.description}</p>
                                </div>
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OverviewColumnSection;
